'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LocaleLabel = require('./components/LocaleLabel.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/locale-label/index.js
// module id = 920
// module chunks = 0